import script from "./DatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=1855c510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1855c510"]])

export default __exports__